import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import get from 'just-safe-get';
import usePatchParams from '../usePatchParams';
import { useEffect, useRef } from 'react';
import { isDefined } from '@/utils/miscUtils';
import { NumericFormatInput } from '@/components/core/form/NumericFormatInput';

const AnnualChangeBase = ({ param, name, className, options = {}, disabled = false }) => {
  const { value, is_default: isDefault, default: defaultValue } = param ?? {};
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();

  const fieldName = `annual_change.${name}`;
  const error = get(errors, fieldName);
  const errorMessage = error?.message;
  const { patchParam } = usePatchParams(options);
  const numericValueRef = useRef(null);

  const events = {
    onChange: e => {
      e.preventDefault();
    },
    onBlur: async e => {
      const prevValue = getValues(fieldName);
      const value = numericValueRef.current ?? parseFloat(e.target.value.replace(/,/g, ''));

      if (prevValue !== value) {
        await patchParam(name, 'annual_change', value, fieldName);
      } else {
        setValue(fieldName, value, { shouldValidate: true, shouldDirty: false });
      }
    },
  };

  useEffect(() => {
    if (isDefined(value)) {
      setValue(fieldName, value, { shouldValidate: true, shouldDirty: false });
    }
  }, [value, fieldName, setValue]);

  return (
    <NumericFormatInput
      id={name}
      name={fieldName}
      control={control}
      {...events}
      placeholder={defaultValue?.toString()}
      hasError={!!errorMessage}
      isDefault={isDefault}
      readOnly={disabled}
      disabled={disabled}
      onNumericChange={value => {
        numericValueRef.current = value;
      }}
      className={className}
    />
  );
};

AnnualChangeBase.propTypes = {
  param: PropTypes.object,
  label: PropTypes.string,
  paramSchema: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.object,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

export default AnnualChangeBase;
